import Api from '@/api/index'

const state = {
  all: [],
}

const getters = {}

const actions = {
  async getAll({ commit }, params) {
    const users = await Api.User.getAll(params)
    if (users !== null) {
      commit('setUsers', users)
      return users
    }
    return []
  },

  async getById(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const user = await Api.User.getById(params)
    if (user !== null) {
      return user
    }
    return null
  },

  async getRoles() {
    const roles = await Api.User.getRoles()
    if (roles !== null) {
      return roles
    }
    return []
  },

  async save(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    user
  ) {
    const result = await Api.User.save(user)
    return result
  },
  async disable(
    {
      commit, // eslint-disable-line no-unused-vars
    },
    params
  ) {
    const result = await Api.User.disable(params)
    return result
  },
}

const mutations = {
  setUsers(state, users) {
    state.all = users.items
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
